import React, { Component } from "react";
import itone from "../../assets/walkin/ITOnelogo.png";
import scg from "../../assets/feednews/scg_logo.png";
import email from "../../assets/walkin/email.png"; 
import phone from "../../assets/walkin/phone_call.png"; 
import web from "../../assets/walkin/web.png";

import "./wk.style.css";

export default class FooterLogo extends Component {
  render() {
    return (
      <div>
        <div className="wk-footer-logos">
          <img src={scg} alt="SCG Logo" className="wk-company-logo" />
          <img src={itone} alt="IT One Logo" className="wk-company-logo" />
        </div>

        <div className="sgn-footer-wrapper">
          <div className="sgn-icon1">
            <img src={email} alt="Email Icon" className="icon_email1" />
            <span className="sgn-title3">itone-cs@itone.co.th</span>
          </div>
          <div className="sgn-icon1">
            <img src={phone} alt="Phone Icon" className="icon_phone1" />
            <span className="sgn-title3">02-271-5191</span>
          </div>
        </div>

      </div>
    );
  }
}
